import React from "react"
import {Link} from "gatsby"

export default (props) => (
  <nav className="navigation"> 
    <Link to="/contact">Contact</Link>
  </nav>
  
)